import { Record, Map } from 'immutable';
import uniqueId from '../../utils/uniqueId';
import {
  SET_MESSAGE,
  UNSET_MESSAGE,
  CLEAR_MESSAGE
} from './actions';

const Message = new Record({
  id: '',
  content: '',
  messageType: '',
  fieldErrors: null,
  raw: false
});

export const InitialState = new Record({
  messages: new Map()
});

export default (state = new InitialState(), action) => {
  switch (action.type) {
    case SET_MESSAGE: {
      const { content, messageType, fieldErrors, raw, slotId } = action;
      return state.setIn(['messages', slotId],
        new Message({
          id: uniqueId(),
          content,
          messageType,
          fieldErrors,
          raw
        })
      );
    }
    case UNSET_MESSAGE: {
      const { id, slotId } = action;
      const { id: currentId } = state.getIn(['messages', slotId]);
      if (id === currentId) {
        return state.deleteIn(['messages', slotId]);
      }
      return state;
    }
    case CLEAR_MESSAGE: {
      const { slotId } = action;
      return state.deleteIn(['messages', slotId]);
    }
    default: {
      return state;
    }
  }
};
